import EntityFinderTabBase from "./EntityFinderTabBase.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";
import { TASK_BUDGET_FIELDS } from "../../../other/constants/OtherKeys.jsx";

export default class EntityFinderBudgetTab extends EntityFinderTabBase {

  static get $name() {
    return "EntityFinderBudgetTab";
  }

  static get type() {
    return "entityfinderbudgettab";
  }

  static get configurable() {
    return super.getTabWidget("Budgets", {type: WIDGET_KEYS.columnEntityMainName, text: "Budgets", field: TASK_BUDGET_FIELDS.budgetTitleDisplayValue})
  }

  onOpenEntityEditor({ record }) {
    this.editorHandler.openEditor(EDITOR_KEYS.budgetEditor, record, { budget: record });
  }

  get storeKey() {
    return STORE_KEYS.taskBudgetStore;
  }

  loadRecord(record, context, otherParams) {
    if (!otherParams.isOnlyFinder) {
      this.disabled = true;
    } else {
      this.disabled = false;
      super.loadRecord(record, context, otherParams);
    }
  }
}

EntityFinderBudgetTab.initClass();